import { useContext, useEffect, useState } from 'react'
import { AppContext } from '../../../contextApi/ContextApi';
import { DashboardContext } from '../../../contextApi/DashboardContext';

export default function AboutSection({section, inx, editFlag, handleChanges}) {
    const {currentWebsite, accent_color, primary_color, setToastMessage, messagesOptions} = useContext(AppContext);
    const {handleDeleteItem} = useContext(DashboardContext);
  const [sectionHeader, setSectionHeader] = useState(section.header);
  const [sectionContent, setSectionContent] = useState(section.content);

  useEffect(()=>{
    handleChanges(inx, {...section, header: sectionHeader, content: sectionContent});
  }, [sectionContent, sectionHeader])


    return (
    <div className='aboutSection' style={{backgroundColor:primary_color, color:accent_color}}>
        {editFlag ? null : <div className='aboutSection_xBtn' style={{backgroundColor:accent_color, color:primary_color}} onClick={()=>{handleDeleteItem(currentWebsite.id, "settings.about", section, setToastMessage, messagesOptions)}}>X</div>}
        <h2>מקטע {inx+1}</h2>
        {editFlag ? 
            <div className='aboutSection_subDiv' style={{borderRight:`1px solid ${accent_color}`}}>
                <input className='aboutSection_subDiv_input' value={sectionHeader} type='text' placeholder='כותרת' onChange={(e)=>{setSectionHeader(e.target.value.slice(0,45))}}/>
                <textarea className='aboutSection_subDiv_textarea' value={sectionContent} placeholder='תוכן' onChange={(e)=>{setSectionContent(e.target.value)}}/>
            </div> : 
            <div className='aboutSection_subDiv' style={{borderRight:`1px solid ${accent_color}`}}>
                <div className='aboutSection_subDiv_h4_div'>
                    <h4 className='aboutSection_subDiv_h4'>{sectionHeader==="" ? "לא הוגדרה כותרת" : `כותרת: ${sectionHeader}`}</h4>
                </div>
                <div className='aboutSection_subDiv_p_div' style={{borderTop:`1px solid ${accent_color}`}}>
                    <p className='aboutSection_subDiv_p'>{sectionContent==="" ? "לא הוגדר תוכן" : `תוכן: ${sectionContent}`}</p>
                </div>
            </div>
        }
    </div>
  )
}
